angular.module('gym.reports').factory('ContactReports', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('contact_reports');
}]);
